import {getNowDateWidthOffsetToLocal} from '@/common/helpers/date/getNowDateWidthOffsetToLocal';

/**
 * Returns nearest to now a hour for the array
 */
export function getNearestHour(hours: number[], timezoneOffset?: number) {
	// Get date with offset to a local one  timezone
	const nowDate = timezoneOffset !== undefined ? getNowDateWidthOffsetToLocal(timezoneOffset) : new Date();

	const nowHours = nowDate.getHours();

	// Total count of minutes from a day start
	const nowTotalMinutes = nowHours * 60 + nowDate.getMinutes();

	// If there is an exact match for an hour, then we return it,
	// even if the next one is closer in calculation (in case more than 30 minutes aster this hour)
	const exactMatch = hours.find(hour => hour === nowHours);
	if (exactMatch) {
		return exactMatch;
	}

	return hours.reduce((lastHour, hour) => {
		return Math.abs(hour * 60 - nowTotalMinutes) < Math.abs(lastHour * 60 - nowTotalMinutes) ? hour : lastHour;
	}, 0);
}
